// mui
import { Box, Stack } from '@mui/material';

const DOT_COUNT = 3;
const DOT_STAGGER_S = 0.16;

/** TypingDots is the three dots in the bubble the next question lands in. */
export const TypingDots = () => (
  <Stack
    direction='row'
    spacing={1.5}
    aria-label='Typing'
    sx={{
      alignItems: 'center',
      height: 14,
      '@keyframes chat-typing': {
        '0%, 60%, 100%': { opacity: 0.25, transform: 'translateY(0)' },
        '30%': { opacity: 1, transform: 'translateY(-3px)' },
      },
    }}
  >
    {Array.from({ length: DOT_COUNT }).map((_, i) => (
      <Box
        key={i}
        sx={{
          width: 6,
          height: 6,
          borderRadius: '50%',
          bgcolor: 'text.secondary',
          animation: 'chat-typing 1.2s infinite ease-in-out',
          animationDelay: `${i * DOT_STAGGER_S}s`,
        }}
      />
    ))}
  </Stack>
);

TypingDots.displayName = 'TypingDots';
export default TypingDots;
